import React, { useState } from "react";
import { Flex } from "@UI/Components/Flex/Flex";
import { Bold } from "@UI/Components/Bold/Bold";
import { Link } from "@UI/Components/Link/Link";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "../messages";
import { Money } from "@Shared/Components/Money/Money";

export const OtherExpenses = ({ linkedExpenses }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      {isOpen &&
        linkedExpenses.map((expense, index) => (
          <Flex justifyContent="space-between" flexGrow="1" key={index} ml={3}>
            <Flex>{expense?.description}</Flex>
            <Flex>
              <Bold>
                <Money
                  cents={expense?.amountCents}
                  currency={expense?.amountCurrency}
                />
              </Bold>
            </Flex>
          </Flex>
        ))}

      <Flex ml={3}>
        <Link
          onClick={handleClick}
          fontSize="sm"
          textDecoration="underline"
          color="gray.500"
        >
          {isOpen ? (
            <FormattedMessage {...messages.hideDetails} />
          ) : (
            <FormattedMessage {...messages.viewDetails} />
          )}
        </Link>
      </Flex>
    </>
  );
};
